import festive from "../assets/christmas.png";

export default festive